import { showAutoToast } from "../../utils/toast";
import { isRetryCancelled } from "../../utils/apiError";
import "./styles.scss";

const ORIGIN = window.location.origin;
const HOSTS = [new URL(ORIGIN).host, "localhost:8100", "capacitor"];

export default {
  name: "ArticlePage",

  data() {
    return {
      content: {},
      fetchError: false,

      scripts: `function injectCheckboxes(){$(".checkbox").wrapInner("<label></label>"),$(".checkbox").prepend('<input type="checkbox" onclick="checkboxClicked(this)">')}function initCheckboxes(e){var c=$("input:checkbox"),i=0,n=e.length;for(i=0;i<n;++i)c[e[i].MAIncidentCheckboxDictionaryKeyOrder].checked=1==e[i].MAIncidentCheckboxDictionaryKeyChecked}function getCheckboxValueByIndex(e){return $("input:checkbox")[e].checked}function setCheckboxValueByIndex(e,c){$("input:checkbox")[e].checked=1==c}function checkboxClicked(e){var c=$("input:checkbox"),i=0,n=c.length;for(i=0;i<n;++i)if(c[i]==e){window.location="checkboxClicked/"+i;break}}$(document).ready(function(){$(".action-show-all").click(function(){$(this).parents("ul:first").find("li").slideDown(),$(this).parent().find(".action-show-top").show(),$(this).hide()}),$(".action-show-top").click(function(){$(this).parents("ul:first").find("li.overflow").slideUp(),$(this).parent().find(".action-show-all").show(),$(this).hide()})});`,
    };
  },

  computed: {
    item() {
      return this.$store.getters.getArticle(this.$route.params.slug);
    },

    list() {
      return this.$store.getters.getArticleList(this.item.parent_topic);
    },

    list_item() {
      return this.$store.getters.getArticleGroup(this.item.parent_topic);
    },

    previous_list_item() {
      if (this.list_item.parent_topic) {
        return this.$store.getters.getArticleGroup(this.list_item.parent_topic);
      } else {
        return undefined;
      }
    },

    backURL() {
      let backURL;

      if (this.$store.state.desktop) {
        if (this.item.parent_topic === 10001) {
          // parent topic is emergency events
          backURL = "/action";
        }

        if (
          this.item.parent_topic === 10002 ||
          this.item.parent_topic === 10003
        ) {
          // parent topic is recovery or preparedness
          backURL = "/action/operations";
        }

        if (
          this.list_item.parent_topic === 10001 ||
          (this.previous_list_item &&
            (this.previous_list_item.id === 10001 ||
              this.previous_list_item.parent_topic === 10001))
        ) {
          // emergency events or emergency events base
          backURL = "/action/emergency-events";
        }

        if (
          this.list_item.parent_topic === 1002 ||
          (this.previous_list_item &&
            (this.previous_list_item.id === 10002 ||
              this.previous_list_item.parent_topic === 10002))
        ) {
          // recovery or recovery base
          backURL = "/action/operations/recovery";
        }

        if (
          this.list_item.parent_topic === 1003 ||
          (this.previous_list_item &&
            (this.previous_list_item.id === 10003 ||
              this.previous_list_item.parent_topic === 10003))
        ) {
          // preparedness or preparedness base
          backURL = "/action/operations/preparedness";
        }

        if (
          this.previous_list_item &&
          this.previous_list_item.id !== 10001 &&
          this.previous_list_item.id !== 10002 &&
          this.previous_list_item.id !== 10003
        ) {
          // add list to existing url
          backURL += `/list-${this.previous_list_item.id}`;
        }
      } else {
        if (
          this.item.parent_topic === 10001 ||
          this.list_item.parent_topic === 10001 ||
          (this.previous_list_item &&
            this.previous_list_item.parent_topic === 10001)
        ) {
          // parent topic is emergency events
          backURL = "/action/emergency-events";
        }

        if (
          this.item.parent_topic === 10002 ||
          this.list_item.parent_topic === 10002 ||
          (this.previous_list_item &&
            this.previous_list_item.parent_topic === 10002)
        ) {
          // parent topic is recovery
          backURL = "/action/operations/recovery";
        }

        if (
          this.item.parent_topic === 10003 ||
          this.list_item.parent_topic === 10003 ||
          (this.previous_list_item &&
            this.previous_list_item.parent_topic === 10003)
        ) {
          // parent topic is preparedness
          backURL = "/action/operations/preparedness";
        }

        if (this.previous_list_item) {
          if (
            this.previous_list_item.id !== 10001 &&
            this.previous_list_item.id !== 10002 &&
            this.previous_list_item.id !== 10003
          ) {
            backURL += `/list-${this.previous_list_item.id}`;
          }
        }

        if (this.list_item) {
          if (
            this.list_item.id !== 10001 &&
            this.list_item.id !== 10002 &&
            this.list_item.id !== 10003
          ) {
            backURL += `/list-${this.list_item.id}`;
          }
        }
      }

      return backURL;
    },

    online_status() {
      return this.$store.state.online_status;
    },
  },

  watch: {
    online_status(newStatus) {
      if (newStatus && (!this.content.data || this.fetchError)) {
        this.getArticle();
      }
    },

    "$route.params.slug"() {
      this.content = {};
      this.fetchError = false;
      this.getArticle();
    },
  },

  created() {
    this.getArticle();

    this.$store.commit("setMenuItems", this.list);
    this.$store.commit("setMenuDetails", {
      title: this.list_item.name,
      slug: this.list_item.slug,
      back_url: this.backURL,
    });
    this.$store.commit("setBackURL", this.backURL);
  },

  methods: {
    
    handleArticleClick(e) {
      // Ignore clicks on links (they're handled by linkClicked method)
      if (e.target.tagName === "A" || e.target.closest("a")) {
        return;
      }

      // Handle article card click here
      console.log("Article card clicked:", this.item.id);
      showAutoToast(`Article ${this.item.id} clicked`, "info-toast");

      // Add your custom logic here
      // For example: navigate somewhere, open modal, etc.
    },

    async getArticle() {
      this.fetchError = false;

      const ctx = {
        article_id: this.item.id,
        subscription_id: this.$store.state.subscriptions.active_subscription.id,
        prefix: this.item.prefix_url,
      };
      try {
        const article = await this.$store.dispatch("getArticleContent", ctx);
        this.content = article;
        if (this.content && this.content.data) {
          this.$nextTick(() => {
            this.runScripts();
            this.attachEvents();
          });
        } else {
          this.fetchError = true;
          showAutoToast("Unable to fetch data ", "error-toast");
        }
      } catch (err) {
        console.error(err);
        this.fetchError = true;
        if (!isRetryCancelled(err)) {
          showAutoToast("Unable to fetch article. Please check your internet connection.", "error-toast");
        }
      }
    },

    runScripts() {
      eval(this.scripts);
    },

    formatPhoneNumber(phoneNumberString) {
      let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          "",
        );
      }
      return null;
    },

    attachEvents() {
      let anchors = this.$refs.content.getElementsByTagName("a");

      if (anchors) {
        let el;
        for (el of anchors) {
          let attached = el.classList.contains("event-attached");
          if (el.href.startsWith("tel:")) {
            let formatted = this.formatPhoneNumber(el.href);
            if (formatted) {
              el.href = `tel:${formatted}`;
            }
          }
          if (!attached) {
            el.addEventListener("click", this.linkClicked, true);
            el.classList.add("event-attached");
          }
        }
      }
    },

    linkClicked(e) {
      let url = e.target.href;
      let localhost = /^http:\/\/localhost|^\/\//i.test(url);
      let web_url = /^https?:\/\/|^\/\//i.test(url);
      let capacitor = /^capacitor:\/\/localhost|^\/\//i.test(url);
      let mail = /^mailto:|^\/\//i.test(url);
      let phone = /^tel:|^\/\//i.test(url);
      let show = /^javascript/i.test(url);
      let relative =
        !localhost && !capacitor && !mail && !phone && !show && !web_url;

      e.preventDefault(relative);

      if (show) {
        return;
      }

      if (url.startsWith(window.location.origin)) {
        url = url.split(window.location.origin)[1];
        relative = true;
      }

      if (relative) {
        let resolve = this.$router.resolve(url);
        this.$router.push(url + "#linked");
      } else {
        let urlObject;
        if (url.startsWith("//")) {
          url = "http:" + url;
        }
        urlObject = new URL(url);
        if (phone) {
          document.location.href = url;
        } else if (HOSTS.indexOf(urlObject.host) === -1) {
          window.open(url, "_blank");
        } else {
          let relativeURL = urlObject.href.replace("capacitor://localhost", "");
          relativeURL = relativeURL.replace("http://localhost:8100", "");
          this.$router.push(relativeURL + "#linked");
        }
      }
    },
  },
};
